<template>
  <div class="mockdetails">
    <div class="inner" v-loading="answallLoading">
      <div class="mockcenter">
        <div class="mock_left">
          <!-- 考试标题和信息 -->
          <div class="mock_info">
            <p class="mockpaper_tit">{{ paperData.title }}</p>
            <div class="paper_info">
              <p>考试题数：{{ allItem.length }}道</p>
              <p>考试时间：{{ totalexam }}分钟</p>
              <p>满分：{{ paperData.totalScore }}分</p>
            </div>
          </div>
          <div class="paper_content">
            <p class="qutype" v-if="quData.quType == 1">
              一、单选题
              <span class="qumiaoshu">(共{{ paperData.radioList.length }}题)</span>
            </p>
            <p class="qutype" v-if="quData.quType == 2">
              二、多选题
              <span class="qumiaoshu">(共{{ paperData.multiList.length }}题)</span>
            </p>
            <p class="qutype" v-if="quData.quType == 3">
              三、判断题
              <span class="qumiaoshu">(共{{ paperData.judgeList.length }}题)</span>
            </p>

            <p class="qutit" v-if="quData.content">
              <span class="qutpe_span">{{
                quData.quType == 1
                  ? "单选题"
                  : quData.quType == 2
                  ? "多选题"
                  : quData.quType == 3
                  ? "判断题"
                  : ""
              }}</span>
              {{ quData.sort + 1 }}.{{ quData.content }}
              <span class="qumiaoshu">({{ quData.score }}分)</span>
            </p>

            <div
              v-if="quData.quType === 1 || quData.quType === 3"
              style="margin-top: 10px"
            >
              <div class="radiogroup">
                <p
                  v-for="item in quData.answerList"
                  :key="item.id"
                  class="radio_p"
                  :class="
                    item.isRight == true
                      ? 'radiotrue'
                      : item.id == radioValue
                      ? 'radioActive'
                      : ''
                  "
                >
                  {{ item.abc }}. {{ item.content }}
                </p>
              </div>
            </div>
            <div v-if="quData.quType === 2" style="margin-top: 10px">
              <p
                v-for="item in quData.answerList"
                :key="item.id"
                class="radio_p"
                :class="
                  item.isRight == true
                    ? 'radiotrue'
                    : item.checked == true
                    ? 'radioActive'
                    : ''
                "
              >
                {{ item.abc }}. {{ item.content }}
              </p>
            </div>
            <!-- 答案及解析 -->
            <div class="answer_analysis">
              <div class="answer_list">
                <span class="answersp"
                  >正确答案：<span class="color1">{{ quokabc.toString() }}</span>
                </span>
                <span class="answersp"
                  >我的答案：<span
                    :class="quData.isRight == true ? 'color1' : 'color2'"
                    >{{ myselabc.toString() || "未作答" }}</span
                  >
                </span>
                <span class="answersp"
                  >正确人数：<span class="color3">{{ quData.rightCount }}</span>
                </span>
              </div>
              <!-- 解析 -->
              <p class="analyops">
                题目解析：<span class="color3">{{ quData.analysis || "暂无" }}</span>
              </p>
              <p class="analyops">
                答案解析：<span class="color3">{{
                  quanalysis.toString() || "暂无"
                }}</span>
              </p>
            </div>
            <div style="margin-top: 20px">
              <el-button
                v-if="showPrevious"
                :loading="quloading"
                icon="el-icon-back"
                @click="handPrevious()"
              >
                上一题
              </el-button>

              <el-button
                v-if="showNext"
                type="warning"
                style="background: #045923; border: 1px solid #045923"
                :loading="quloading"
                icon="el-icon-right"
                @click="handNext()"
              >
                下一题
              </el-button>
            </div>
          </div>
        </div>
        <div class="mock_rig">
          <!-- 题目 -->
          <div class="exam_rigbotm">
            <div class="tagtishi">
              <el-tag>正确</el-tag>
              <el-tag type="danger">错误</el-tag>
              <el-tag type="info">未作答</el-tag>
              <el-tag type="warning">当前题目</el-tag>
            </div>
            <div
              v-if="paperData.radioList !== undefined && paperData.radioList.length > 0"
            >
              <p class="card-title">单选题</p>
              <el-tag
                v-for="item in paperData.radioList"
                :key="item.id"
                style="cursor: pointer"
                :type="cardItemClass(item)"
                @click="handSave(item)"
              >
                {{ item.sort + 1 > 9 ? item.sort + 1 : "0" + (item.sort + 1) }}</el-tag
              >
            </div>
            <div
              v-if="paperData.multiList !== undefined && paperData.multiList.length > 0"
            >
              <p class="card-title">多选题</p>

              <el-tag
                v-for="item in paperData.multiList"
                :key="item.id"
                style="cursor: pointer"
                :type="cardItemClass(item)"
                @click="handSave(item)"
                >{{ item.sort + 1 }}</el-tag
              >
            </div>
            <div
              v-if="paperData.judgeList !== undefined && paperData.judgeList.length > 0"
            >
              <p class="card-title">判断题</p>

              <el-tag
                v-for="item in paperData.judgeList"
                :key="item.id"
                style="cursor: pointer"
                :type="cardItemClass(item)"
                @click="handSave(item)"
                >{{ item.sort + 1 }}</el-tag
              >
            </div>
            <div class="postexams">
              <el-button
                style="width: 100%; background: #045923; border: 1px solid #045923"
                type="primary"
                @click="backrouter"
              >
                返回首页
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { paperDetail, papercreate, quDetail, paperResult } from "@/api/mockExamination";
import { Loading } from "element-ui";
export default {
  name: "mockdetails",
  data() {
    return {
      // 当前页
      thisPage: "",
      // 全屏/不全屏
      isFullscreen: false,
      showPrevious: false,
      showNext: true,
      loading: false,
      handleText: "交卷",
      pageLoading: false,
      // 试卷ID
      paperId: "",
      // 当前答题卡
      cardItem: {},
      allItem: [],
      // 当前题目内容
      quData: {
        answerList: [],
      },
      // 试卷信息
      paperData: {
        leftSeconds: 99999,
        radioList: [],
        multiList: [],
        judgeList: [],
      },
      // 单选选定值
      radioValue: "",
      // 多选选定值
      multiValue: [],
      // 已答ID
      answeredIds: [],
      examId: "",
      answallLoading: false,
      quloading: false,
      totalexam: 0, //考试总时长
      handpaper: null,
      countTime: null, //定时器
      myselabc: [], //我的答案
      quokabc: [], //正确答案
      quanalysis: [], //答案解析
    };
  },
  created() {
    this.$store.commit("user/SET_TABINDEX", 999);
  },
  mounted() {
    const id = this.$route.query.id;
    this.totalexam = this.$route.query.totalexam;
    //我的考试---查询试卷
    if (this.$route.query.examstate) {
      this.paperId = this.$route.query.paperId;
      this.fetchData(this.paperId);
    }
  },
  methods: {
    goBack() {
      // console.log("点击了浏览器的返回按钮");
      history.pushState(null, null, document.URL);
    },

    // 答题卡样式
    cardItemClass(item) {
      //当前题
      if (item.quId === this.cardItem.quId) {
        return "warning";
      }
      //答对的
      if (item.answered && item.isRight) {
        return "";
      }
      //答错的
      if (item.answered && item.isRight == false) {
        return "danger";
      }
      //未答的
      if (!item.answered) {
        return "info";
      }
    },

    /**
     * 统计有多少题没答的
     * @returns {number}
     */
    countNotAnswered() {
      let notAnswered = 0;

      this.paperData.radioList.forEach(function (item) {
        if (!item.answered) {
          notAnswered += 1;
        }
      });

      this.paperData.multiList.forEach(function (item) {
        if (!item.answered) {
          notAnswered += 1;
        }
      });

      this.paperData.judgeList.forEach(function (item) {
        if (!item.answered) {
          notAnswered += 1;
        }
      });

      return notAnswered;
    },

    /**
     * 下一题
     */
    handNext() {
      this.quloading = true;
      const index = this.cardItem.sort + 1;
      this.handSave(this.allItem[index]);
    },

    /**
     * 上一题
     */
    handPrevious() {
      this.quloading = true;
      const index = this.cardItem.sort - 1;
      this.handSave(this.allItem[index]);
    },
    // 保存答案
    handSave(item, callback) {
      if (item.id === this.allItem[0].id) {
        this.showPrevious = false;
      } else {
        this.showPrevious = true;
      }

      // 最后一个索引
      const last = this.allItem.length - 1;
      if (item.id === this.allItem[last].id) {
        this.showNext = false;
      } else {
        this.showNext = true;
      }

      const answers = this.multiValue;
      if (this.radioValue !== "") {
        answers.push(this.radioValue);
      }
      // 查找详情
      this.fetchQuData(item);
    },
    // 试卷详情
    fetchQuData(item) {
      // 打开
      // const loading = Loading.service({
      //   text: "拼命加载中",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });

      // 获得详情
      this.cardItem = item;
      // 查找下个详情
      const params = { paperId: this.paperId, quId: item.quId };
      quDetail(params).then((response) => {
        this.quData = response.data;
        this.radioValue = "";
        this.multiValue = [];
        this.quokabc = [];
        this.myselabc = [];
        this.quanalysis = [];
        // 填充该题目的答案
        this.quData.answerList.forEach((item) => {
          // 用户选择的题目
          if ((this.quData.quType === 1 || this.quData.quType === 3) && item.checked) {
            this.radioValue = item.id;
            this.myselabc.push(item.abc);
          }

          if (this.quData.quType === 2 && item.checked) {
            this.multiValue.push(item.id);
            this.myselabc.push(item.abc);
          }
          // 该题的答案
          if ((this.quData.quType === 1 || this.quData.quType === 3) && item.isRight) {
            this.quokabc.push(item.abc);
            if (item.analysis) {
              let analysis1 = item.analysis;
              this.quanalysis.push(analysis1);
            }
          }

          if (this.quData.quType === 2 && item.isRight) {
            this.quokabc.push(item.abc);
            if (item.analysis) {
              let analysis2 = item.abc + "." + item.analysis;
              this.quanalysis.push(analysis2);
            }
          }
        });

        // 关闭详情
        // loading.close();
        this.quloading = false;
      });
    },
    // 试卷详情
    fetchData(id) {
      const params = { id: id };
      paperDetail(params).then((response) => {
        // 试卷内容
        this.paperData = response.data;
        // 获得第一题内容
        if (this.paperData.radioList.length > 0) {
          this.cardItem = this.paperData.radioList[0];
        } else if (this.paperData.multiList.length > 0) {
          this.cardItem = this.paperData.multiList[0];
          console.log("a2");
        } else if (this.paperData.judgeList.length > 0) {
          this.cardItem = this.paperData.judgeList[0];
        }

        const that = this;

        this.paperData.radioList.forEach(function (item) {
          that.allItem.push(item);
        });

        this.paperData.multiList.forEach(function (item) {
          that.allItem.push(item);
        });

        this.paperData.judgeList.forEach(function (item) {
          that.allItem.push(item);
        });
        // 当前选定
        this.fetchQuData(this.cardItem);

        this.answallLoading = false;
      });
    },
    //创建考试
    createExam() {
      this.answallLoading = true;
      let data = { examId: this.examId };
      papercreate(data).then((res) => {
        this.paperId = res.data.id;
        this.fetchData(res.data.id);
      });
    },
    //查询结果
    Resultpaper() {
      paperResult({ id: this.paperId }).then((res) => {
        this.handpaper = res.data;
      });
    },
    //返回列表
    backrouter() {
      this.$router.push({ path: "/personal-center" });
    },
    //个人中心
    myrouter() {
      this.$router.push({ path: "/personal-center" });
    },
  },
};
</script>
<style scoped>
.mockdetails {
  width: 100%;
  background: #f5f5f5;
}
.mockcenter {
  padding: 20px 0;
  min-height: 600px;
  overflow: hidden;
}
.mock_left {
  width: 67%;
  min-height: 600px;
  background-color: #ffffff;
  float: left;
  padding: 24px 0;
}
.mock_info {
  border-bottom: 1px solid #f5f5f5;
  overflow: hidden;
}
.paper_content {
  padding: 26px 50px;
}
.qutit {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  padding: 10px 0;
  line-height: 1.6;
}
.qutype {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.qutpe_span {
  display: inline-block;
  padding: 2px 6px;
  background: #045923;
  border-radius: 4px;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
}
.qumiaoshu {
  color: #b8b8b8;
  font-size: 14px;
  font-weight: 400;
}

.mockpaper_tit {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  text-align: center;
}
.paper_info {
  width: 400px;
  margin: 10px auto;
  display: flex;
  justify-content: space-around;
  color: #555555;
  font-size: 14px;
  font-weight: 500;
}
.mock_rig {
  width: 30%;
  min-height: 600px;
  background-color: #ffffff;
  float: right;
  position: relative;
}

.el-checkbox-group label,
.el-radio-group label {
  width: 100%;
}

.card-title {
  line-height: 35px;
  font-size: 16px;
  color: #333333;
}
.card-line {
  padding-left: 10px;
}
.card-line span {
  cursor: pointer;
  margin: 2px;
}

/deep/ .el-radio,
.el-checkbox {
  padding: 9px 20px 9px 10px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  margin-bottom: 10px;
}

.is-checked {
  border: #409eff 1px solid;
}

.el-radio img,
.el-checkbox img {
  max-width: 200px;
  max-height: 200px;
  border: #dcdfe6 1px dotted;
}

/deep/ .el-checkbox__inner {
  display: none;
}

/deep/ .el-radio__inner {
  display: none;
}

/deep/ .el-checkbox__label {
  line-height: 30px;
  font-size: 16px;
  color: #333333;
}

/deep/ .el-radio__label {
  line-height: 30px;
}
/deep/ .el-radio__input .is-disabled >>> .el-radio__label {
  color: #409eff !important;
}
.exam_ider {
  width: 100%;
  height: 10px;
  background: #f5f5f5;
}
.exam_rigbotm {
  margin: 5px 14px;
}
.tagrig {
  margin: 10px 0 0 0;
}
.eilog_tiAll {
  width: 100%;
  border-radius: 5px;
}
.eilog_tiAll > span {
  display: inline-block;
  width: 49.5px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #999999;
  cursor: pointer;
  user-select: none;
  margin: 0 -1px -1px 0;
}
.eilog_tiAll > span:hover {
  color: #409eff;
}
.activSpan {
  background-color: #409eff;
  color: #ffffff;
}
/* 交卷按钮 */
.postexams {
  width: 90%;
  position: absolute;
  bottom: 20px;
  left: 14px;
}
/* 完成考试后的数据 */
.overexam {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  text-align: center;
}
.overexam_score {
  font-size: 16px;
  color: #409eff;
  text-align: center;
  margin: 30px 0;
}
.exam_scoretxt {
  font-size: 60px;
}
.exam_Statlist {
  width: 400px;
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
}
.exam_statitem {
  text-align: center;
}
.exam_xian {
  width: 2px;
  height: 50px;
  background-color: #f5f5f5;
}
.exam_message {
  font-size: 16px;
  font-weight: bold;
  color: #999999;
  text-align: center;
  margin-top: 50px;
  letter-spacing: 1px;
}
.examItem_p1 {
  font-size: 14px;
  font-weight: bold;
  color: #555555;
}
.examItem_p2 {
  font-size: 16px;
  font-weight: bold;
  color: #409eff;
  margin-top: 11px;
}
.exam_butflex {
  display: flex;
  justify-content: space-around;
  margin-top: 70px;
}
.exam_fanh {
  width: 262px;
  height: 42px;
  border-radius: 4px;
}
/* 试题选项 */
.radiogroup {
  overflow: hidden;
}
.radio_p {
  font-size: 14px;
  padding: 15px 15px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  margin-top: 20px;
  color: #606266;
}
.radioActive {
  border: #ff4e4f 1px solid;
  color: #ff4e4f;
}
.radiotrue {
  border: #409eff 1px solid;
  color: #409eff;
}
/* 答案及解析 */
.answer_list {
  padding: 10px 0;
  margin-left: -40px;
}
.answersp {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  margin: 0 40px;
}
/* 我的答案字体颜色 */
.color1 {
  color: #409eff;
  font-weight: 400 !important;
}
.color2 {
  color: #ff4e4f;
  font-weight: 400 !important;
}
.color3 {
  color: #555555;
  font-weight: 400 !important;
}
/* 解析 */
.analyops {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  margin: 10px 0;
}
/* 题目tag */
.tagtishi {
  width: 100%;
  margin-top: 15px;
  display: flex;
  justify-content: space-around;
  margin-left: -10px;
}
</style>
